module.exports = __webpack_public_path__ + "static/img/rank-default.201d439a.png";